module.exports = __webpack_public_path__ + "img/hr-centrifuge-B.6b00d8f6.png";